import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 7234382E-CB5D-4EB3-8BA2-0C50BC2171DB
 * name arrow-split-vertical
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-split-vertical.svg
 * tags
 * - Arrow 
 */
export const ArrowSplitVerticalIcon = createSvgIcon(<><path d="M18,16V13H15V22H13V2H15V11H18V8L22,12L18,16M2,12L6,16V13H9V22H11V2H9V11H6V8L2,12Z" /></>, 'ArrowSplitVerticalIcon');
export default ArrowSplitVerticalIcon